import React, { memo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { WAVEFORM_HEIGHT } from './audioUtils';

const WaveformDisplay = memo(({ waveformRef, isLoading, colors }) => {
    return (
        <Box 
            sx={{ 
                position: 'relative',
                bgcolor: colors.bgSecondary,
                borderRadius: 1.5,
                overflow: 'hidden',
                border: `1px solid ${colors.borderSecondary}`,
                mb: 2,
                minHeight: WAVEFORM_HEIGHT
            }}
        >
            {isLoading && (
                <Box 
                    sx={{ 
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 10
                    }}
                >
                    <CircularProgress size={40} />
                </Box>
            )}
            <div 
                ref={waveformRef} 
                style={{ 
                    width: '100%',
                    opacity: isLoading ? 0.3 : 1,
                    transition: 'opacity 0.3s ease'
                }}
            />
        </Box>
    );
});

WaveformDisplay.displayName = 'WaveformDisplay';

export default WaveformDisplay;

